import { convertHexToRGBA } from "@Utils/Formatters/opacityColor"

export const getStatusTagColor = (status: string) =>
    ({
        won: 'rgba(0, 255, 0, 0.1)',
        lost: 'rgba(255, 0, 50, 0.1)',
        default: convertHexToRGBA('#000000', 0.1),
        open: 'rgba(0, 100, 255, 0.2)',
    }[status] || convertHexToRGBA('#000000', 0.1))
